import * as types from "../actions/types";


const initialState = {
    webRTConnection: null,
    linkedPortalAgent: undefined,
    callSession: null
};


export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case types.GET_WEBRTCONNECTION_COMPLETED:
            return Object.assign({}, state, {
                webRTConnection: action.payload
            });
        case types.GET_LINKEDPORTALAGENT_COMPLETED:
            return Object.assign({}, state, {
                linkedPortalAgent: action.payload
            });
        case types.GET_CALLSESSION_COMPLETED:
            return Object.assign({}, state, {
                callSession: action.payload
            });

        default:
            return state;
    }
};
